import { useCallback } from 'react';
import deepCamelizeKeys from "../../../../utils/object/deepCamelizeKeys.js";
import { API_HOST_NAME } from "../constants.js";
import { useAuthentication } from "../../../../../contexts/AuthenticationContext.jsx";

const BASE_URL = `${API_HOST_NAME}/api/v1/auth/two_factor`;

const useTwoFactorAuth = () => {
  const { getValidToken } = useAuthentication()

  const authenticatedFetch = useCallback((path, options = {}) => {
    return getValidToken()
      .then((accessToken) => {
        return fetch(`${BASE_URL}/${path}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          ...options,
        })
      })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(`Request failed: ${response.status}`)
          error.status = response.status
          return Promise.reject(error)
        }
        return response.json()
      })
      .then((data) => deepCamelizeKeys(data))
  }, [getValidToken])

  const setup = useCallback(() => {
    return authenticatedFetch('setup')
  }, [authenticatedFetch])

  const activate = useCallback((code) => {
    return authenticatedFetch('activate', {
      body: JSON.stringify({
        two_factor: { code }
      }),
    })
  }, [authenticatedFetch])

  const deactivate = useCallback((code) => {
    return authenticatedFetch('deactivate', {
      body: JSON.stringify({
        two_factor: { code }
      }),
    })
  }, [authenticatedFetch])

  return { setup, activate, deactivate };
};

export default useTwoFactorAuth;
